module.exports = __webpack_public_path__ + "static/img/bg2.bef82f40.png";